/** @format */
import { Component, Inject, Input } from '@angular/core';
import { WINDOW } from '@shared/data-access/services';
import { HmfButtonComponent } from '@dsg-tech/homefield-angular';

@Component({
	selector: 'pdp-feedback',
	templateUrl: './feedback.component.html',
	styleUrl: './feedback.component.scss',
	imports: [HmfButtonComponent]
})
export class FeedbackComponent {
	@Input()
	public formId: string;

	constructor(@Inject(WINDOW) protected window: Window) {}
	public loadSurvey() {
		if (typeof this.window.KAMPYLE_ONSITE_SDK !== 'undefined') {
			this.window.KAMPYLE_ONSITE_SDK.showForm(this.formId);
		}
	}
}
